import React, {Component} from 'react'
import {connect} from 'react-redux'
import {withRouter} from 'react-router-dom'
import getUsername from 'screens/login/actions/getUsername'
import getCsrfToken from 'screens/login/actions/getCsrfToken'
import getLoginPageUrl from 'screens/login/actions/getLoginPageUrl'
import {bindActionCreators} from "redux"


const Authentication = (WrappedComponent) => {
    class WithAuthentication extends Component {
        componentDidMount() {
            this.props.actions.getUsername()
            this.props.actions.getLoginPageUrl()
        }

        redirectToLoginPage() {
            if (this.props.authenticated === false && this.props.loginUrl)
                window.location.assign(this.props.loginUrl + window.location.href)
        }

        render() {
            this.redirectToLoginPage()
            return (
                !this.props.isLoading && this.props.authenticated ?
                    <WrappedComponent {...this.props} signOut={this.props.actions.signOut}/> : null
            )
        }

    }

    const mapStateToProps = (state) => {
        return {
            authenticated: state.user.authenticated,
            loginUrl: state.user.loginUrl,
            isLoading: state.user.isLoading,
            CSRF: state.user.CSRF
        }
    }

    const mapDispatchToProps = (dispatch) => ({
        actions: bindActionCreators({
            getUsername,
            getCsrfToken,
            getLoginPageUrl
        }, dispatch)
    })

    return withRouter(connect(mapStateToProps, mapDispatchToProps)(WithAuthentication))
}

export default Authentication


// WEBPACK FOOTER //
// ./src/shared/hoc/authentication/index.js